var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 981.565,
    height: 374.67,
    viewBox: "0 0 981.565 374.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_48244",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 48244",
    transform: "translate(-108.438 -224.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_48242",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 48242",
    transform: "translate(108.439 224.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13045",
    "data-name": "\\u30D1\\u30B9 13045",
    d: "M666.148,291.126a43.857,43.857,0,0,0-87.313-8.349l-.045-.059a43.052,43.052,0,0,1-6.887,15.3c-13.8,19.378-40.521,20.229-57.18,13.224a40.825,40.825,0,0,0-38.613.028,46.673,46.673,0,0,1-14.28,5.4c-24.842,4.972-52.014-16.479-54.5-35.178a63.024,63.024,0,0,0-25.008-41.958A64.045,64.045,0,0,0,293.1,252.472a63.035,63.035,0,0,0,13.027,88.608,64.054,64.054,0,0,0,69.411,4.294l.014.1c40.067-22.871,72.579-3.937,82.413,16.85a40.358,40.358,0,0,0,1.78,3.7,40.8,40.8,0,0,0,55.123,16.251,40.293,40.293,0,0,0,19.551-23.9l.01,0c9.678-28.308,43.717-44.915,66.581-33.4a44.145,44.145,0,0,0,48.17-3.435l0-.017A43.49,43.49,0,0,0,666.148,291.126Z",
    transform: "translate(315.212 -218.421)",
    fill: "#5584c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13046",
    "data-name": "\\u30D1\\u30B9 13046",
    d: "M632.921,245.484a34.622,34.622,0,0,0-45.76,26.881c-6.714,23.29-30.656,11.978-38.291,3.961l.042.132c-.308-.3-.616-.6-.928-.893a85.285,85.285,0,0,0-119.991,2.763l.017-.111c-22.955,20.818-58.527,10.624-70.079-13.841l-.017.128a63.7,63.7,0,0,0-47.976-38.977c-34.738-6.216-67.974,16.718-74.231,51.221-5.443,27.165-29.243,33.367-49.933,19.374A49.566,49.566,0,0,0,117.2,309.049a48.859,48.859,0,0,0,29,75.495,49.358,49.358,0,0,0,59.545-36.13l.062.042c5.838-29.5,30.562-32.8,48.71-14.374l.048-.073a64.164,64.164,0,0,0,94.675-7.337c.031-.017.031.028.073-.014,15-16.15,49.576-6.642,55.615,19.655l.017-.111.09.066c5.225,44.153,44.036,76.714,88.743,74.449,46.879-2.375,82.943-42.045,80.554-88.6-2.694-21.431,7.795-35.961,28.748-25.063a34.424,34.424,0,1,0,29.835-61.564Z",
    transform: "translate(-108.438 -224.511)",
    fill: "#56bcaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_48243",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 48243",
    transform: "translate(108.438 471.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13047",
    "data-name": "\\u30D1\\u30B9 13047",
    d: "M173.219,420.246H108.438V296.377H121.95V408.7h51.269Z",
    transform: "translate(-108.438 -294.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13048",
    "data-name": "\\u30D1\\u30B9 13048",
    d: "M197.324,332.628c-2.607-8.453-4.713-16.254-6.344-23.578h-.488c-1.631,7.48-3.906,15.292-6.178,23.09l-28.166,88.106h-13.83l41.006-123.869h15.631L239.96,420.246H225.642Z",
    transform: "translate(-25 -294.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13049",
    "data-name": "\\u30D1\\u30B9 13049",
    d: "M296.072,332.628c-2.607-8.453-4.713-16.254-6.344-23.578h-.488c-1.631,7.48-3.906,15.292-6.178,23.09L254.9,420.246H241.066l41.006-123.869H297.7l41.006,123.869H324.39Z",
    transform: "translate(218.19 -294.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13050",
    "data-name": "\\u30D1\\u30B9 13050",
    d: "M289.052,417.782c-5.689,2.76-16.76,5.516-30.922,5.516-31.888,0-57.6-20.641-57.6-62.575,0-40,24.887-64.861,61.18-64.861,14.81,0,23.439,3.078,27.342,5.028l-3.58,11.379a53.985,53.985,0,0,0-23.425-5.028c-28.166,0-47.363,18.858-47.363,52.994,0,32.508,17.58,51.685,46.539,51.685,9.439,0,18.713-2.105,24.9-5.028Z",
    transform: "translate(118.363 -295.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13051",
    "data-name": "\\u30D1\\u30B9 13051",
    d: "M372.477,370.379c0,37.228-19.2,51.7-43.949,51.7-23.1,0-41.494-13.494-41.494-50.875V296.425h13.512v74.93c0,28.131,12.365,39.51,28.64,39.51,17.9,0,29.78-12.033,29.78-39.51v-74.93h13.512Z",
    transform: "translate(331.397 -294.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13052",
    "data-name": "\\u30D1\\u30B9 13052",
    d: "M393.527,312.923a42.207,42.207,0,0,0-21.8-5.682c-17.262,0-23.772,10.558-23.772,19.5,0,12.2,7.487,18.37,24.094,25.361,20.008,8.456,30.268,18.692,30.268,36.421,0,19.665-14.319,34.776-41.006,34.776-11.237,0-23.439-3.411-29.627-7.8l3.75-11.212a50.578,50.578,0,0,0,26.687,7.632c16.59,0,26.365-8.941,26.365-22.269,0-12.189-6.68-19.668-22.785-26.171-18.723-6.991-31.41-17.882-31.41-34.943,0-18.858,15.295-32.674,37.924-32.674,11.711,0,20.662,2.926,25.375,5.849Z",
    transform: "translate(441.346 -295.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13053",
    "data-name": "\\u30D1\\u30B9 13053",
    d: "M438.432,420.246H373.01V296.377h62.662v11.378h-49.15v41.934h46.221v11.226H386.521v47.952h51.91Z",
    transform: "translate(543.134 -294.594)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.08d9ab24aa2a48ce07dd4dee8da8b208.svg";
export { ForwardRef as ReactComponent };